module.exports = __webpack_public_path__ + "media/images/like-83bc43c5aeca1f51ecf412796b9a2228.png";